const es = {
    common: {
        app_name: 'Ranger American',
        save: 'Salvar',
        reset: 'Eliminar',
        id: 'ID',
        description: 'Descripción',
        ok: 'Ok',
        cancel: 'Cancelar',
        yes: 'Si',
        no: 'No',
        next: 'Siguiente',
        previous: 'Previo',
        search: 'Buscar',
        delete: 'Borrar',
        confirm_delete_title: 'Confirmar eliminar titulo',
        confirm_delete_message: '¿Está seguro que quiere eliminarlo?',
        profile: 'Perfil',
        logout: 'Ingresar',
        none: 'Ninguna',
        select: 'Seleccionar',
        side_menu: {
            route_mgmt: 'Gestión de rutas',
            route_control: 'Liberación de la ruta',
            check_in: 'registrarse',
            check_out: 'revisa',
            bag_out: 'Bolsa hacia fuera',
            settings: 'Ajustes',
            route_sheet: 'Hoja de ruta',
            route_release: 'Liberación de la ruta',
            shipment_batch: 'Lote de envío',
            coin_pull_report: 'Reporte de monedas',
            setup: 'Preparar'
        },

        all: ''
    },
    home: {

    },
    routeSheet: {
        route: 'Ruta',
        date: 'Día',
        show: 'Mostrar',
        print: "Imprimir",
        routePlaceHolder: 'Marcador de ruta'
    },
    routeControl: {
        adHocCheckinNoUnassignedRoute: 'No se encontró una ruta no asignada para esta sucursal. Configure una ruta no asignada en la configuración.',
        adHocCheckinTitle: 'Registro Ad-Hoc | ',
        checkInAction: 'Registrar'
    },
    login: {
        button: 'Ingresar',
        remember_me: 'Recordar',
        remember_me_message: 'No abilitar esta opción si esta en una computadora publica.',
        email: 'Correo',
        password: 'Contraseña',
        forgot_password: '¿Olvidé la contraseña?',
        change_password: '¿Cambiar contraseña?',
        email_placeholder: 'Tu correo o Nombre de usuario',
        password_placeholder: 'Contraseña',
        forgot_email_placeholder: 'Enter your e-mail',
        code: 'Code',
        reset_code_placeholder: 'Enter Code',
        password_placeholder: 'Enter your password',
        confirm_password: 'Confirm password',
        confirm_password_placeholder: 'Enter your confirm password',
        reset_request_success: 'Password reset successfully, Please try to login now!',
        forgot_password_label: 'Forgot Password',
        change_password_label: 'Change Password',
        reset_password_label: 'Reset Password',
        reset_password_request_code: 'Your forgot password code shared on the registered email address. Please check your inbox',
        force_change_password_message: 'You need to update your password. your password has expired. password will expire every',
        password_policy_criteria_message: 'Your current password does not satisfy the password policy criteria. Please reset your password to continue.',
        duplicate_password_warning: 'Your new password should not be same as your current password.',
        resend_code: 'Resend code',
        login_2FA__code_placeholder: 'Enter the 6-digit code sent to your email to complete the login process.'
    },
    batch: {
        menu: {
            title: 'Lote',
            create: 'Nuevo lote',
            all: 'Todos los Lotes'
        },
        batches: 'Lote',
        all_batches: 'Todos los lotes',
        create_batch: 'Nuevo lote',
        edit_batch: 'Editar lote',
        inputType: 'Tipo de entrada',
        batchSourceId: 'ID Fuente de lote',
        tooltip_delete: 'Eliminar lote',
        tooltip_edit: 'Editar lote',
        tooltip_reload: 'Refrescar',
        tooltip_del: 'Eliminar',
        create_another_title: 'Crear lote',
        create_another_message: 'Desea crear otro lote?',
        location: 'Ubicación',
        tooltip_info : '',
        noBatches: 'Sin lotes'
    },
    users: {
        menu: {
            title: 'Usuarios',
            create: 'Nuevo Usuario',
            all: 'Todos los usuarios'
        },
        branchId: 'Sucursal',
        role: 'Roles',
        permission: 'Permitir',
        users: 'Usuario',
        all_users: 'Todos los usuarios',
        create_users: 'Nuevo usuario',
        edit_users: 'Editar usuario',
        name: 'Nombre',
        firstName: 'Primer nombre',
        lastName: 'Apellido',
        email: 'Correo',
        languageId: 'Lenguaje',
        supervisor: 'Supervisor',
        user: 'Usuario',
        password: 'Contraseña',
        cnfpassword: 'Confirmar contraseña',
        E: 'Ingles',
        F: 'Frances',
        S: 'Español',
        tooltip_delete: 'Eliminar usuario',
        tooltip_edit: 'Editar Usuario',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Usuario',
        create_another_message: '¿Deseá crear otro usuario?',
        noUsers: 'Sin usuarios',
        handheldUser: 'Usuario de mano',
        webUser: 'Usuario web',
        confirm_password_error : "",
    },
    route: {
        menu: {
            title: 'Ruta',
            create: 'Nueva Ruta',
            all: 'Todas las Rutas'
        },

        route: 'Ruta',
        name: 'Nombre',
        shortName: 'Abreviación',
        loadTruck: 'Camion de carga',
        beginTime: 'Iniciar ahora',
        branchId: 'Sucursal',
        all_routes: 'Ruta',
        tag: 'Rutas de entraga utuilazadas por Ranger American',
        create_route: 'Nueva ruta',
        edit_route: 'Editar Ruta',
        tooltip_delete: 'Eliminar Ruta',
        tooltip_edit: 'Editar Ruta',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Ruta',
        create_another_message: '¿Desea crear otra ruta?',
        routeSequence: 'Secuencia de Ruta',
        noRouteSequenceLocation: 'No hay ubicación que use esta ruta',
        noRoutes: 'Sin rutas',
        holdRoute: 'Mantener rutas'
    },
    shiptype: {
        menu: {
            title: 'Entrega',
            create: 'Nueva Entrega',
            all: 'Todas las entrgas'
        },
        status: 'Estado',
        shiptype: 'Entrega',
        all_shiptype: 'Todas las entregas',
        create_shiptype: 'Nueva Entrega',
        edit_shiptype: 'Editar Entrega',
        id: 'ID de Entrega',
        description: 'Descripción',
        unitValue: 'Valor unitario',
        coin: 'Moneda',
        useAmount: 'Cantidad en uso ',
        amount: 'Monto',
        handheld: 'Portatil',
        batchDisplay: 'Visualización por lotes',
        shipmentID: 'IDs de Entrega',
        tooltip_delete: 'Eliminar Entrega',
        tooltip_edit: 'Editar Entrega',
        tooltip_reload: 'Refrescar',
        suspend_shiptype: 'Confirmar',
        suspend_shiptype_message: '¿Está seguro que desea realizar este envío inactivo?',
        create_another_title: 'Crear Entrega',
        create_another_message: '¿Deseá crear otro tipo de entrega?',
        noShiptypes: 'No hay barcos'
    },
    location: {
        menu: {
            title: 'Ubicación',
            create: 'Nueva Ubicación',
            all: 'todas las Ubicaciones'
        },
        location: 'Ubicación',
        id: 'ID',
        all_locations: 'todas las Ubicaciones',
        create_location: 'Nueva Ubicación',
        edit_location: 'Editar Ubicación',
        tooltip_delete: 'Eliminar Ubicación',
        tooltip_edit: 'Editar ubicación',
        tooltip_reload: 'Refrescar',
        suspend_location: 'Confirmar',
        suspend_location_message: '¿Está seguro que desea suspender esta Ubicación?',
        create_another_title: 'Crear Ubicación',
        create_another_message: '¿Desea crear otra Ubicación?',
        status: 'Estado',
        customer: 'Cliente',
        branch: 'Sucursal',
        _address: 'Dirección exacta',
        _city: 'Ciudad',
        _state: 'Estado',
        _zip: 'Ubicación Zip',
        refId: 'ID de Referencia',
        _poc: 'Ubicación PDC',
        pocPhone: 'Telefono PDC',
        pocEmail: 'Correo PDC',
        deliveries: 'Entregas',
        pickups: 'Recolecciones',
        day: {
            routeId: 'ID de Ruta',
            stops: 'Paradas',
            options: 'Opciones'
        },
        seasonStart: 'Inicio de Temporada',
        seasonEnd: 'Final de Temporada',
        startTime: 'Hora de inicio',
        endTime: 'Hora de Finalización',
        locationType: 'Tipo de Ubicación',
        keyId: 'Clave de ID',
        maxDepositAmount: 'Cantidad de Deposito Maximo',
        roundedDeposits: 'Deposito Redondeado',
        codAllow: 'COD Permitido',
        allowMulti: 'Paradas multiples Permitidas',
        individualBagout: 'Bolsa Individual',
        deliveryLoc1: '1ra Opción de Distribución',
        deliveryLoc2: '2da Opción de Distribución',
        deliveryLocCoin: 'Distribución de monedas',
        deliveryLocCod: 'COD Distribución',
        lastTransaction: 'Ultima Transacción',
        _leave: 'Salir Localización',
        atmCassette: 'Cinta ATM',
        maxCassettes: 'Máximo de Casetes',
        TRdeliveries: 'Entregas',
        TRpickups: 'Recolecciones',
        latitude: 'Latitud',
        longitude: 'Longitud',
        general: 'General',
        routeNotification: 'Notificaiones de Ruta',
        routeAssignment: 'Ruta Asignada',
        deliveryBackoutTimes: 'Plazo de entrega',
        deliveryLocations: 'Ubicación de entrega',
        routeOptions: 'Opción de ruta',
        transactionRequirements: 'Transacción requerida',
        sameForAll: 'Lo mismo para todos',
        _type: 'Tipo de locación',
        transactionRequirments: 'Transacción requerida',
        scan: 'Escanear',
        receipts: 'Recibos',
        GPSlocation: 'Localización GPS',
        mon: 'Lunes',
        tues: 'Martes',
        wed: 'Miercoles',
        thurs: 'Jueves',
        fri: 'Viernes',
        sat: 'Sabado',
        sun: 'Domingo',
        hol: 'Feriado',
        contract: 'Contrato',
        weekday: 'Día laborable',
        route: 'Ruta',
        stop: 'Parada',
        when: 'Cuando',
        scan_bagout_pieces: 'Escanear bolsas',
        packCoinSeparately: 'Empaquetar moneda por separado',
        tooltip_info : '',
        noLocations: 'Sin ubicaciones',
        name: 'Nombre'
    },
    carrier: {
        menu: {
            title: 'Mensajero',
            create: 'Nuevo Mensajero',
            all: 'Todos los Mensajeros'
        },
        name: 'Nombre de Transportista',
        POCEmail: 'Correo PDC',
        POCPhone: 'Telefono PDC',
        POCName: 'Nombre PDC',
        carrier: 'Mensajero',
        all_carriers: 'todos Mensajeros',
        create_carrier: 'Nuevo Mensajero',
        edit_carrier: 'Editar Mensajero',
        tooltip_delete: 'Eliminar Mensajero',
        tooltip_edit: 'Editar Mensajero',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Mensajero',
        create_another_message: '¿Desea crear otra Mensajero?',
        noCarriers: 'Ninguna compañía'
    },
    message: {
        menu: {
            title: 'Mensaje',
            create: 'Nuevo Mensaje',
            all: 'todos los mensajes'
        },
        types: {
            N: 'N',
            M: 'Mensajes',
            T: 'Etiqueta de campo',
            R: 'Refusal / No Pickup',
            SM: 'Envio Perdido',
            NP: 'No Recoger'
        },
        messages: 'Mensajes',
        all_messages: 'todos los Mensajes',
        create_message: 'Nuevo Mensaje',
        edit_message: 'Editar Mensaje',
        tooltip_delete: 'Eliminar Mensaje',
        tooltip_edit: 'Editar Mensaje',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Mensaje',
        create_another_message: '¿Deseá crear otro Mensaje?',
        messageId: 'ID de mensaje',
        type: 'Tipo',
        descriptionIn: 'Descripción en',
        noMessages: 'Ningún mensaje',
        all: 'Todas'
    },
    item: {
        menu: {
            title: 'Artículo',
            create: 'Nuevo Artículo',
            all: 'Todos los Artículos'
        },
        items: 'Artículo',
        all_items: 'Todos los artículos',
        create_item: 'Nuevo Artículo',
        edit_item: 'Editar Artículo',
        tooltip_delete: 'Eliminar Artículo',
        tooltip_edit: 'Editar Artículo',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Artículo',
        create_another_message: 'Crear otro mensaje',
        location: 'Ubicación',
        name: 'Nombre',
        noItems: 'Ninguna articulo',
        type: 'Tipo'
    },
    branch: {
        menu: {
            title: 'Sucursal',
            create: 'Nueva Sucursal',
            all: 'Todas las sucursales'
        },
        branches: 'Sucursales',
        all_branches: 'Todas las Sucursales',
        create_branch: 'Nueva Sucursal',
        edit_branch: 'Editar Sucursal',
        tooltip_delete: 'Eliminar Sucursal',
        tooltip_edit: 'Editar Sucursal',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Sucursal',
        create_another_message: '¿Deseá Crear otra Sucursal?',
        windows: 'Ventanas',
        tooltip_window_delete: 'Eliminar Ventana',
        tooltip_window_save: 'Salvar Ventana',
        confirm: 'Confirmar',
        confirm_delete_message: '¿Está seguro de querer eliminar ventana?',
        noBranches: 'Sin ramas'
    },
    vault: {
        menu: {
            title: 'Bóveda',
            create: 'Nueva Bóveda',
            all: 'Todas las Bóvedas'
        },
        vaults: 'Bóvedas',
        all_vaults: 'Todas las Bóvedas',
        create_vault: 'Nueva Bóveda',
        edit_vault: 'Editar Bóveda',
        tooltip_delete: 'Eliminar Bóveda',
        tooltip_edit: 'Editar Bóveda',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Bóveda',
        create_another_message: '¿Deseá crear otra Bóveda?'
    },
    customer: {
        menu: {
            title: 'Clientes',
            create: 'Nuevo Cliente',
            all: 'todos los Clientes'
        },
        name: 'Nombre',
        contact: 'Contacto',
        delete_title: 'Eliminar Contrato',
        delete_message: '¿Deseá eliminar este contrato?',
        customers: 'Clientes',
        all_customers: 'Todos los Clientes',
        create_customer: 'Nuevo Cliente',
        edit_customer: 'Editar Cliente',
        tooltip_delete: 'eliminar Cliente',
        tooltip_edit: 'Editar Cleinte',
        tooltip_reload: 'Refrescar',
        tooltip_delete_contract: 'Eliminar Contrato',
        create_another_title: 'Crear Cliente',
        create_another_message: '¿Deseá crear otro cliente?',
        suspend_customer: 'Confirmar',
        suspend_customer_message: '¿Está seguro de suspender este cleinte?',
        status: 'Estado',
        billing: 'Facturación',
        address: 'Dirección',
        city: 'Ciudad',
        state: 'Estado',
        zip: 'Zip',
        POC: 'PDC',
        phone: 'Telefono',
        email: 'Correo',
        contracts: 'Contratos',
        billToContract: 'Factura para Contrato',
        billToCustomer: 'factura para el cliente',
        transport: 'Transporte',
        deposit: 'Depósito',
        changeOrder: 'Cambiar orden',
        serviceSchedule: 'Horario de Servicio',
        contractOverrides: 'Anulaciones de Contrato',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha final',
        orderBasis: 'Base del pedido',
        orderRate: 'Tarifa de orden',
        standardCoins: 'Moneda estandar',
        serviceOption: 'Opción de Servicio',
        unitBasis: 'Unidad base',
        unitRate: 'Unidad de medida',
        billToCategory: 'Proyecto de ley a la categoría',
        actions: 'Comportamiento',
        noCustomers: 'Sin clientes',
        contractDetails : 'Contract Details',
        accountingId: 'ID de contabilidad'
    },

    truck: {
        menu: {
            title: 'Camiones',
            create: 'Nuevo Camion',
            all: 'Todas los Camiones'
        },
        make: 'Marca',
        model: 'Modelo',
        year: 'Año',
        vinnum: 'Numero VIN',
        platenum: 'Placa Vehicular',
        trucks: 'Camiones',
        all_trucks: 'Todos los Camiones',
        create_truck: 'Nuevo Camion',
        edit_truck: 'Editar Camion',
        tooltip_delete: 'Eliminar Camion',
        tooltip_edit: 'Editar camion',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear camion',
        create_another_message: '¿Deseá crear otro camion?',
        suspend_truck: 'Confirmar',
        suspend_truck_message: '¿Está seguro que desea suspender este camion?',
        tooltip_info : '',
        noTrucks: 'no camonines'
    },

    checkin: {
        title: 'Titulo',
        waitForMessenger: 'Espere por mensaje',
        waitForRoute: 'Espere por la ruta',
        waitForWindow: 'Espere por la ventana',
        successfullyCheckedin: 'Entrada exitosa',
        successfullySaved: 'Guardado exitosamente',
        branch: 'Sucursal',
        route: 'Ruta',
        window: 'Ventana',
        truck: 'Camion',
        close_route: 'Cerrar Ruta',
        override: 'Anular',
        save_override: 'Salvar anulación',
        item: 'Artículo',
        customer: 'Cliente',
        location: 'Locación',
        type: 'Tipo',
        amount: 'Valor',
        destination: 'Destino',
        scan: 'Escanear',
        checkedin: 'Entrada',
        putOnHold: 'Puesto en espera',
        force_close: 'Cerrada forzosa',
        quantity: 'Cantidad',
        remainingItems: 'No articulo restantes',
        shipper: 'Expedidor'
    },
    contract: {
        menu: {
            title: 'Contratos',
            create: 'Nuevo Contrato',
            all: 'todos los Contratos'
        },
        all_contracts: 'Todos los Contratos',
        edit_contract: 'Editar Contrato',
        billToCategory: 'Categoria de factura',
        billToInformation: 'Información de factura',
        contact: 'Contacto',
        changeOrder: 'Cambiar Orden',
        deposits: 'Depositos',
        transport: 'Transporte',
        contractDetails: 'Detalle de Contacto',
        contractId: 'ID de contrato',
        contractName: 'Nombre de contrato',
        contractCustomer: 'Customer',
        contractStatus: 'estado de contrato',
        contractStartDate: 'Fecha de Inicio',
        contractEndDate: 'Fecha Final',
        contract: 'Contrato',
        serviceSchedule: 'Horario de Servicio',
        orderBasis: 'Base de Pedidos',
        orderRate: 'Tarifa de Orden',
        seasonStartDate: 'Inicio de Temporada',
        seasonEndDate: 'Final de Temporada',
        holidayService: 'Servicio de Vacaciones',
        standardCoins: 'Moneda Estandar',
        serviceOption: 'Opción de Servicio',
        unitBasis: 'Unidad de Base',
        unitRate: 'Unidad de Medida',
        actions: 'Comportamiento',
        tooltip_delete: 'Eliminar Contrato',
        tooltip_edit: 'Editar Contrato',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Contrato',
        create_another_message: '¿Deseá crear otro Contrato?',
        noContracts: 'no contratos'
    },
    shipmentBatch: {
        refId: 'ID destino de Referencia',
        currency: 'Efectivo',
        tracking_id: 'ID de Rastreo',
        description: 'Descripción/Notas',
        action: 'Acción',
        add: 'Agregar',
        total: 'Total',
        commit: 'Hacer',
        batch_master: 'Lote Maestro',
        customer: 'Cliente',
        deliveryDate: 'Día de entrega',
        tooltip_del: 'Eliminar',
        route: 'ruta',
        location: 'ubicación',
        reset: 'restaurar',
        delete_message: 'eliminar mensaje',
        invalidLocationMessage: 'Ubicación de mensaje invalida',
        alertModalTitle: 'Título modal de alerta',
        alertModalMessage: 'Mensaje modal de alerta',
        locationPlaceholder: 'Ubicación',
        uploadedFiles: 'Subir Archivos',
        tooltip_info : ''
    },
    routeControl: {
        menu: {
            title: 'Control de Ruta'
        },
        release: 'Emisión',
        route: 'Ruta',
        branch: 'Sucursal',
        routeDate: 'Fecha de la Ruta',
        all: 'Todo',
        stops: 'Paradas',
        totalCash: 'Efectivo Total',
        controls: 'Inspecciones',
        branchPlaceholder: 'Select a Branch...',
        getRoutes: 'Traer rutas',
        noRoutesFound: 'No rutas encontradas',
        printCoin: 'Imprimir moneda' ,
        printRoute: 'imprimir ruta',
        routeReleaseFailed: 'liberation de ruta fracasado',
        routeReleasedSuccessfully: 'Liberation de ruta exitosa',
        routesReleaseFailed: 'liberación de ruta fracasado',
        routesReleasedSuccessfully: 'liberation de rutas exitosa.',
        shipments: 'Envíos'
    },
    setup: {
      menu: {
        all: 'Todos',
        create: 'Crear',
        title: 'Titulo',
      },
      all_setups: 'Todas la configuraciones',
      setups: 'Instauraciones',
      create_setup: 'Crear instauracion',
      edit_setup: 'editar instauracion',
      tooltip_delete: 'Herramienta eliminada',
      tooltip_edit: 'Editar Herramienta',
      tooltip_reload: 'Recargar Herramienta',
      create_another_message: 'Crear otro mensaje',
      create_another_title: 'Crear otro titulo',
      suspend_setup: 'Suspender la instauracion',
      suspend_setup_message: 'Suspender',
      noSetups: 'No Instauraciones',
      address: 'Direccion',
      setupFor: 'Instauracion para ',
      state: 'Estado',
      city: 'Ciudad',
      zip: 'zip',
      telno: 'número de teléfono',
      fromLocation: 'Desde la ubicación',
      holdRoute: 'Mantener la ruta',
      exitPassword: 'contraseñas de salida',
      confirmExitPassword: 'confirma contraseña de salida',
      dataFromServer: 'Información de el Servidor',
      dataToServer: 'Información para el Servidor',
      fromHHTProtocol: 'De el  HTT Protocolo',
      toHHTProtocol: 'Para HTT Protocol',   
      transmitMsgFiles: 'Trasmitir archivos de mensaje',
      keyVerify: 'clave de verificación',
      verify: 'Verificar',
      showCoinTotal: 'Muestra total de monedas',
      noPrintDelivery: 'No impression de la entrega',
      noPrintPickup: 'No impression de el levante',
      coinCheckIn: 'Moneda Registrada',      
      currentVaultDate: 'fecha actual de la boveda',
      imageDirectory: 'Imagen de el Directorio',
      bagoutManifest: 'Salida manifestada',
      branch: 'Sucursal',      
      vault: 'Boveda',
      language: 'lenguaje',
      directoryPathWarning: 'advertencia de el camino a directorio',
      exitPasswordMismatch: 'Contraseñas de salida no son iguales',
      maxItemsPerBagout: 'Max. Items Per Bagout', // need fix
      new_label: 'New' // need fix
    },
    log: {
        menu: {
            title: '',
            all: ''
        },

        tooltip_reload: '',
        noLogs: '',
        extraData: '',
        by: '',
        on: '',
        key: '',
        value: '',
        supervisors: '',
        users: ''
    },
    holiday: {
        menu: {
            title: 'Titulo'
        },
        addHoliday: 'Agregar Dia Festivo',
        createHoliday: 'Crear Dia Festivo',
        editHoliday: 'Editar Dia Festivo',
        branch: 'Sucursal',
        startDate: 'Fecha de Comienzo',
        endDate: 'Fecha de Termino',
        title: 'Titulo',
        name: 'Nombre'
    },
    checkinSelectionModal: {
        title: 'Bolsa no encontrada | Seleccionar Alternativa',
        forceBag: 'Forzar Bolsa',
        select: 'Selecionar'
    },
    checkout: {
      selectRoute: 'Seleccioné Ruta',
      waitForFromTanker: 'Espere por..' ,
      waitForRoute: 'Espere por Ruta',
      waitForToTanker: 'Espere por..'
    },
    routeThrow: {
        title: 'Contratos',
        waitForTanker: 'Espera por el petrolero',
        item: 'It',
        end: 'Fin',
        clear: 'Claro',
        fromTanker: 'De petrolero',
        contents: 'Contenido'
    },
    coinPullReport: {
      coin: 'Moneda',
      date: 'Fecha',
      noDesitnationFound: 'No Destino Encontrado',
      print: 'Imprimir',
      route: 'Ruta',
      routePlaceHolder: 'Ruta en espera',
      show: 'Mostrar',
      title: 'Titulo',
      total: 'Total'
    },
    confirmSupervisorModal: {
        title: 'Supervisor de escaneo',
        password: '',
        idMissing: '',
        passwordMissing: '',
        supervisor: 'Supervisor'
    },
    addBagModal: {
        title: 'Agregar bolsa',
        trackingId: 'ID de Ratreo',
        scanSupervisor: 'Supervisor de escaneo',
        fromLocation: 'De Ubicación',
        all: 'Todos',
        search: '',
        destination: 'Destino',
        quantity: 'Cantidad',
        shiptype: 'Tipo de Envio',
        amount: 'Cantidad',
        requiredFieldsError: 'Erros en Campos Requeridos',
        addItem: 'Agregar Articulo' ,
        bagSeal: 'Sellado de Bolsa',
        carrier: 'Portador',
        batch: 'Lote',
        pleaseSelect: 'Por favor Selecione'
    },
    forceCheckinModal: {
        title: 'Bolsa no esta en ruta',
        forceCheckin: 'Inspección inmediata'
    },
    closeRouteModal: {
        title: 'Cerra Ruta',
        bag: 'Bolsa',
        pickupLocation: 'localizacion de recibido',
        locationType: 'tipo Locación',
        reasonCode: 'Codigo de Causa'
    },
    selectDeliveryLocationModal: {
        title: 'Titulo'
    },
    routeVerifyResultModal: {
        title: 'Titulo'
    },
    forceCLoseRouteModal: {
        title: 'Titulo',
        saveAndClose: 'Cerrar y Guardar',
        not_checked_in: 'No regitrado',
        not_checked_out: 'Sin Salir',
        not_delivered: 'No Deliverado',
        not_picked: 'No Recojido',
        n_a: 'no aplica',
        please_select: 'Por favor Selecione..'
    },
    itemNotDeliveredModal: {
        title: 'Titulo',
        pleaseSelect: 'Por favor Selecione'
    },
    closeBagoutModal: {
        bagoutClosed: 'Bolsa de Salida Cerrada',
        view: 'Mostrar'
    },
    commitSuccessModal: {
        title: 'Titulo',
        message: 'Mensaje',
        total: 'Total'
    },
    bagout: {
        title: 'Bolsa',
        waitForBag: 'Espere por La Bolsa',
        lastScan: 'Ultimo Escaneo',
        wrongDestination: 'Destino Equivicado',
        addedToBagout: 'Aderido a La Bolsa de salida',
        bagNotFound: 'Niguna bolsa encontrada',
        mismatchDestination: 'destino incompatible',
        bagAlreadyAdded: 'Bolsa Aderida',
        previouslyAdded: 'Previamente aderida',
        shipmentNotCheckedIn: 'Envío no Registrado' ,
        notCheckedIn: 'No Registrado',
        onhold: 'En espera',
        shipmentOnHold: 'Envio en Espera',
        closePrint: 'Cierre de Imprecion',
        branch: 'Sucursal',
        bagoutSeal: 'Sello de Bolsa',
        route: 'Ruta',
        deliveryDate: 'Fecha de Entrega',
        item: 'Articulo',
        destination: 'Destino',
        location: 'Locación',
        amount: 'Monto',
        type: 'Tipo',
        customer: 'Cliente',
        fromCustomer: 'Del cliente',
        fromLocation: 'Desde el Origen',
        toLocation: 'Al Destino',
        trackingId: 'ID de Seguimiento',
        from: 'De',
        fromLocationName: 'Nombre de Ubicación',
        fromLocationId: 'ID De Ubicacion',
        goToBagout: 'Para Bolsa de Salida',
        closeBagout: 'Cerrar Bolsa De Salida',
        bagoutClosed: 'Bolsa de Salida Cerrada',
        confirmCloseBagoutTitle: 'Confirmar Titulo De bolsa de Salida',
        confirmCloseBagoutMessage: 'Confirmar mensaje de bolsa de Salida',
        totalBags: '',
        totalAmount: '',
        verify: '',
        totalItems: '',
        success: 'Exito',
        fail: 'Fallo',
        bagout: 'Bolsa de salida',
        added: 'Aderido',
        delivery: 'Entrega'
    },
    errorModal: {
        title: 'Error'
    },
    uploadedFileSelectionModal: {
        title: 'Titulo',
        fromLocation: 'De Ubicación',
        file: 'Titulo',
        carrier: 'Portador',
        totalAmount: 'Monto Total',
        totalBags: 'Total De bolsas',
        deliveryDate: 'Fecha de Entrega',
        arrivalDate: 'Fecha de Llegada' ,
        load: 'Carga',
        fileLockMessage: "Si cargas los archivos y no haces  los cambios, el archivo sera bloqueado por un mínimo de 15 minutos antes de que pueda ser acezado nuevamente.",
        dateError: 'Error de fecha'
    },
    error: { //translate-this:
        8000: 'Contenido XML no válido encontrado',
		90000: 'Invalido Fecha de Boveda Pasado',
        90001: 'Invalido ID de Ruta',
        90002: 'Invalido ID de Ruta ',
        90100: 'Invalido ID de Ruta',
        90101: 'Invalido Fecha de Boveda',
        90102: 'Invalido ID de Camion',
        90103: 'Millas de Comienzo Tiene un Caracter Invalido',
        90104: 'Tiempo de Comienzo de Carga Tiene Caracteres Invalidos',
        90105: 'Tiempo de Finalizacion de Carge Tiene Invalidos Caracteres',
        90106: 'Tiempo de Finalizacion de Carga no Puede Ser Antes de Comienzo de Carga',
        90107: 'Tiempo de Salida es Invalido',
        90108: 'Tiempo de Salida no Puede Ser Antes de Tiempo de Finalzacion de Carga',
        90109: 'Invalido ID de Operador',
        90110: 'Invalido ID de Mensajero',
        90111: 'ID de Operador y ID de Mensajero no Puede Ser el Mismo',
        90112: 'Invalido ID de Ruta',
        90113: 'Esta Ruta ya ha Sido Tomada',
        90114: 'Invalido ID de Camion',
        90115: 'Millas de Comienzo Tiene un Caracter Invalido',
        90116: 'invalido ID de Operador',
        90117: 'Invalido ID de Mensajero',
        90200: 'Invalido ID de Ruta',
        90201: 'Invalido Fecha de Boveda',
        90202: 'Invalido ID de Usuario',
        90203: 'Invalido ID de Usuario',
        90204: 'Invalido ID de Supervisor',
        90205: 'Invalido ID de Ventana',
        90206: 'Invalido ID de Ventana',
        90207: 'Invalido ID de Ruta',
        90208: 'Routa no ha Sido Tomada',
        90300: 'Invalido ID de Ruta',
        90301: 'Invalido Fecha de Boveda',
        90302: 'Invalida GPS latitud',
        90303: 'Invalida GPS latitud',
        90304: 'Invalida GPS longitud',
        90305: 'Invalida GPS longitud',
        90306: 'Invalido ID de Ruta',
        90307: 'Routa no ha Sido Tomada',
        90400: 'Invalido ID de Supervisor',
        90500: 'Invalido ID de Mensajero',
        90501: 'Invalido Fecha de Boveda',
        90502: 'Invalido ID de Mensajero',
        90503: 'ID de Mensajero de Ruta no Encontrado',
        90600: 'Invalido ID de Rastreo',
        90601: 'Routa no Esta Lista o no ha Sido Puesta Para Registrar',
        90602: 'Invalido Fecha de Boveda',
        90603: 'Invalido ID de Usuario',
        90604: 'Invalido ID de Ventana',
        90605: 'Invalido ID de Ventana',
        90606: 'ID de Envarque no ha Sido Encontrado',
        90607: 'Envarque ya ha Sido Registrado',
        90608: 'Ventana no Permitido',
        90609: 'Envarco no Tiene Ubicacion de Entrega',
        90610: 'Transaccion ha Fallado',
        90700: 'Invalido ID de Envarco Ingresado',
        90701: 'Invalido ID de Envarco Ingresado',
        90702: 'Invalido ID bolsa de salida Ingresado',
        90703: 'Bolsa de salida ya ha sido cerrada',
        90704: "Detinacion equivocada <br/> {{trackingId}} | Mismatch Destination <br/> Bagout {{bagoutId}}",
        90705: 'Envarque ya Fue Escaneado Para Bolsa de Salida',
        90706: 'Maximo numero de evarques aderidos a la bolsa de salida',
        90707: 'Este Ubicacion ID no a Sido Preparado en Registro',
        90900: 'Invalido ID de Rastreo',
        90901: 'Invalido Fecha de Boveda',
        90902: 'Routa No Encontrada Porfavor Intente de Nuevo',
        90903: 'Invalida Ruta Seleccionada',
        90904: 'Invalido ID de Ventana',
        90905: 'Articulo no Encontrado',
        90906: 'Envarque ya ha Sido Registrado',
        90907: 'Efectivo no Permitido en Esta Ventana',
        90908: 'Articulo no Deliverado',
        90909: 'Monedas no Permitidas en Esta Ventana',
        90910: 'Ruta ya ha Sido Tomada',
        901000: "Envio {{trackingId}} no deliveredo",
        901001: "Articulo Muestra Levante y Entrega",
        901002: "Articulo no Fue Recogido",
        901003: "Articulo Esta Listo Para Recoger, Pero no Deliveredo",
        901004: "Articulo no Registrado (Usuario Tiene que Salir y Escanear el Articulo)",
        901005: "Articulos Puesto Para Entrega, Pero no Recogido",
        901006: "Articulo no Fue Sacado",
        901007: "Ubicacion Tiene Envios",
        901008: "Ubicacion no Tiene Registros Para Recojer",
        901009: "No Levantamientos regitrados para esta ubicacion",
        901010: "Ubicacion Esta En Espera",
        91201: "Envion no Encontrado",
        91202: "Invalido ID de Rastreo",
        91203: "Invalido Monto",
        91204: "Monto No Puede Ser Negativo",
        91205: "Monto No Puede Ser Cero",
        91206: "Invalido Cantidad",
        91207: "Cantidad no Puede Ser Negativo",
        91208: "Cantidad no Puede Ser Cero",
        91101: "Invalido ID de Rastreo",
        91102: "Invalido Ubicacion de Destino",
        90612: "ID de tanque no válido",
        95008: 'ID de rastreo duplicado',
        11000: 'Porfavor Seleccione una Valida Ventana'
    },
    window: {
        allowCash: 'Permitir Efectivo',
        allowCoin: 'Permitir Monedas'
    },
    connectionStatus: {
        messageConnected: 'Mensaje Conectado',
        messageDisconnected: 'Mensaje Desconectado',

        refreshNow: 'Refrescar ahora'
    }
}

export default es;



// WEBPACK FOOTER //
// ./client/app/language/es.js